import {LocalStorageService} from '../../storage/local-storage.service';
import {StorageData} from '../../../models/storage';

/**
 * A service for managing authentication-related local storage operations.
 */
export class AuthenticationStorageService extends LocalStorageService {
  readonly jwtKey = 'jwt';
  readonly authenticatedKey = 'authenticated';
  readonly NAMESPACE = 'auth';

  set(key: string, value: string) {
    this.storeValue(key, value);
  }

  /**
   * Retrieves the authentication token from storage.
   * @returns The stored authentication token as StorageData.
   */
  getAuthToken(): StorageData {
    return this.get(this.jwtKey);
  }

  setAuthenticated(authenticated: boolean) {
    this.storeValue(this.authenticatedKey, authenticated?.toString() || '');
  }

  isAuthenticated(): boolean {
    return this.get(this.authenticatedKey).getValue() === 'true';
  }

  setAuthToken(value: string): void {
    this.setAuthenticated(true);
    this.set(this.jwtKey, value);
  }

  clearAuthToken(): void {
    this.remove(this.jwtKey);
  }

  isGDBorOpenIDToken(): boolean {
    const token = this.getAuthToken().getValue();
    return !!(token && (token.startsWith('GDB') || token.startsWith('Bearer')));
  }
}
